module.exports = __webpack_public_path__ + "img/arrow-rotate-right.7ebe676a.svg";